export const submittedPathname = "?submitted";
